export default __webpack_public_path__ + "static/media/skirmishers_scepter.ca6c6857.jpg";